import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AccessLinkSiteAdminControlsLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AccessLinkSiteAdminControls" */ './components/AccessLinkSiteAdminControls.tsx'
			)
		).AccessLinkSiteAdminControls,
});
